/* src/app/component/spinner/spinner.component.scss */
/*# sourceMappingURL=spinner.component-5HGXDIRL.css.map */
